<template>
	<div class="login">
		<h1>Bejelentkezés</h1>
		<h3>
			Adminisztrációs felület
		</h3>

		<form class="card login-form" v-on:submit.prevent="login()">
			<md-input-container>
				<label>Projekt</label>
				<md-select v-model="project">
					<md-option v-for="(item, key) in firebaseConfig" :value="key">{{key}}</md-option>
				</md-select>
			</md-input-container>
			<md-input-container>
				<label>E-mail cím</label>
				<md-input v-model="email"></md-input>
			</md-input-container>
			<md-input-container>
				<label>Jelszó</label>
				<md-input type="password" v-model="password"></md-input>
			</md-input-container>
			<md-button class="md-raised" type="submit">Bejelentkezés</md-button>
			<div v-if="errorCode === 'auth/invalid-email'">
			  <b>Hibás e-mail cím</b>
			</div>
			<div v-if="errorCode === 'auth/user-not-found'">
			  <b>Felhasználó nem található</b>
			</div>
			<div v-if="errorCode === 'auth/wrong-password'">
			  <b>Hibás jelszó</b>
			</div>
		</form>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { input as bsInput } from 'vue-strap'
	import * as firebase from "firebase";
	import config from '../config'

	var timer = undefined;

	export default {
		components: {
			bsInput
		},
		data () {
			return {
				email: "",
				password: "",
				errorCode: "",
				errorMessage: "",
				project: config.default,
				firebaseConfig: config.firebaseConfig
			}
		},
		methods: {
			login () {
				firebase.auth().signInWithEmailAndPassword(this.email, this.password)
				.then((user) => {
					this.$router.push('/admin');
				})
				.catch((error) => {
					console.log(error.code);
					this.errorCode = error.code;
				});
			}
		},
		watch: {
			project: function (val) {
				console.log(val);
				Vue.localStorage.set('project', val);
				firebase.app().delete().then(function() {
					firebase.initializeApp(config.firebaseConfig[val]);
				});
			}
		},
		created () {
			var user = firebase.auth().currentUser;

			if (user) {
				console.log("ok");
				this.$router.push('/admin');
			} else {
				console.log("notok");
			}

			firebase.auth().onAuthStateChanged((user) => {
				if (user) {
					this.$router.push('/admin');
				} else {
					console.log("Probably logged out");
				}
			});
		}
	}
</script>

<style scoped>
	h1, h2 {
		font-weight: normal;
	}
	h2 {
		margin-top: 32px;
		margin-bottom: 0;
	}
	h3 {
		margin: 8px;
	}
	.result {
		text-align: left;
		margin: 16px;
	}
	.login-form{
		display: inline-block;
		min-width: 320px;
		max-width: 800px;
		padding: 32px;
		margin: 16px;
	}
	.login-form > *{
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// LoginView.vue?54329430